import apiClient from './api';

export default {
    async getMembers(params = {}) {
        try {
            const response = await apiClient.get('/members', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching members:', error);
            throw error;
        }
    },

    async getMember(id) {
        try {
            const response = await apiClient.get(`/members/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching member ${id}:`, error);
            throw error;
        }
    },

    async createMember(data) {
        const config = data instanceof FormData ? {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        } : {};
        return apiClient.post('/members', data, config);
    },

    async updateMember(id, data) {
        const config = data instanceof FormData ? {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        } : {};
        return apiClient.put(`/members/${id}`, data, config);
    },

    async deleteMember(id) {
        return apiClient.delete(`/members/${id}`);
    },

    async uploadMemberImage(memberId, imageType, file) {
        const formData = new FormData();
        formData.append('file', file);
        return apiClient.post(`/members/${memberId}/upload/${imageType}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    async getMemberOrderSummary(memberId) {
        try {
            const response = await apiClient.get(`/members/${memberId}/order-summary`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching order summary for member ${memberId}:`, error);
            throw error;
        }
    }
};
